import { base } from '$app/paths';

const Navdata = [
	{
		label: 'Menu',
		isHeader: true
	},
	{ label: 'Welcome', icon: 'bx bx-home-circle', link: base + '/welcome' },
	{
		label: 'KdmGen',
		icon: 'bx bxs-key',
		auth_access: ['kdmgen'],
		auth_see: true,
		subMenu: [
			{
				label: 'Welcome',
				link: base + '/kdmgen/welcome'
			},
			{
				label: 'Walk Throughs/Help',
				isChildItem: true,
				childItems: [
					{ label: 'Start here', link: base + '/kdmgen/help/' },
					{ label: 'Device Certs', link: base + '/kdmgen/help/device-certs/' },
					{ label: 'Register DCP/CPL', link: base + '/kdmgen/help/register-dcp-cpl/' },
					{ label: 'Generate KDM', link: base + '/kdmgen/help/generate-kdm/' },
					{ label: 'Facilities/OpenTDL', link: base + '/kdmgen/help/facilities-opentdl/' }
				]
			},
			{
				label: 'Device Certs',
				link: base + '/kdmgen/device_certs'
			},
			{
				label: 'Document Inspector',
				link: base + '/inspect_tool'
			},
			{
				label: 'Register DCP/CPL',
				auth_access: ['kdmgen'],
				auth_see: true,
				link: base + '/kdmgen/register_cpl'
			},
			{
				label: 'Generate KDM',
				auth_access: ['kdmgen'],
				auth_see: true,
				link: base + '/kdmgen/generate_kdm'
			},
			{
				label: 'Facilities/OpenTDL',
				auth_access: ['kdmgen'],
				auth_see: true,
				link: base + '/kdmgen/facilities'
			},
			{
				label: 'Stats',
				auth_access: ['kdmgen'],
				auth_see: false,
				link: base + '/kdmgen/stats'
			},
			{
				label: 'Admin & Debug',
				auth_access: ['admin'],
				auth_see: false,
				link: base + '/kdmgen/admin'
			}
		]
	},
	{
		label: 'DCP Tools',
		icon: 'bx bxs-file',
		auth_access: ['dcp_tools'],
		auth_see: true,
		subMenu: [
			{ label: 'Welcome', link: base + '/dcp_tools/welcome' },
			{
				label: 'Assets (DCPs)',
				auth_access: ['dcp_tools'],
				auth_see: true,
				link: base + '/dcp_tools/assets'
			},
			{ label: 'Ingest upload Help - sftp', link: base + '/dcp_tools/ingest_help' },
			{ label: 'Ingest browser upload', link: base + '/dcp_tools/browser_upload' },
			{
				label: 'Ingest Asset (DCP)',
				auth_access: ['dcp_tools'],
				auth_see: true,
				link: base + '/dcp_tools/ingest'
			},
			{ label: 'WA DCP Player', link: base + '/dcp_tools/local_wa_dcp_player' },
			{ label: 'WA DCP Maker', link: base + '/dcp_tools/local_mp4_mov_to_dcp_maker' },
			{ label: 'WA DCP Audio Fix', link: base + '/dcp_tools/wa_dcp_audio_fix' },
			{ label: 'WA DCP SDR to HDR', link: base + '/dcp_tools/wa_dcp_sdr_to_hdr' },
			{ label: 'WA DCP to Encrypted DCP', link: base + '/dcp_tools/wa_dcp_to_encrypted_dcp' },
			{ label: 'WA DCP CPL rename', link: base + '/dcp_tools/wa_dcp_cpl_rename' },
			{
				label: 'CPL Research',
				auth_access: ['research'],
				auth_see: true,
				link: base + '/dcp_tools/cpl_research'
			}
		]
	},
	{
		label: 'Slate Tools',
		icon: 'bx bx-film',
		auth_access: ['slate_tools'],
		auth_see: true,
		subMenu: [
			{ label: 'Welcome', link: base + '/slate/welcome' },
			{
				label: 'Walk Throughs/Help',
				isChildItem: true,
				childItems: [
					{ label: 'Start here', link: base + '/slate/help/' },
					{ label: 'Movie DB', link: base + '/slate/help/movie-db/' },
					{ label: 'Release Timeline', link: base + '/slate/help/release-timeline/' },
					{ label: 'Booking App', link: base + '/slate/help/booking-app/' },
					{ label: 'Release Analysis', link: base + '/slate/help/release-analysis/' }
				]
			},
			{ label: 'Movie DB', link: base + '/slate/movie_db' },
			{ label: 'Release Timeline', link: base + '/slate/release_timeline' },
			{
				label: 'Booking App',
				auth_access: ['slate_tools'],
				auth_see: true,
				link: base + '/slate/booking_app'
			},
			{ label: 'Release Analysis', link: base + '/slate/release_analysis' }
		]
	},
	{
		label: 'Distributor Tools',
		icon: 'bx bxs-truck',
		auth_access: ['distributor'],
		auth_see: false,
		subMenu: [
			{ label: 'Welcome', link: base + '/distributor/welcome' },
			{ label: 'Reports', link: base + '/distributor/reports' },
			{ label: 'Transfer Monitor', link: base + '/distributor/transfer_monitor' },
			{ label: 'Aloc by Facility', link: base + '/distributor/alloc_by_facility' },
			{
				label: 'Catcher Status',
				auth_access: ['admin'],
				auth_see: true,
				link: base + '/distributor/catcher_status'
			}
		]
	},

	{ label: 'Inspect Cert/KDM/CPL/PKL', icon: 'bx bx-search', link: base + '/inspect_tool' },

	{
		label: 'User Profile',
		auth_see: false,
		auth_access: ['authenticated'],
		icon: 'bx bx-user-circle',
		link: base + '/profile'
	},

	{ label: 'Donations', icon: 'bx bx-dollar-circle', link: base + '/donations' },

	{
		label: 'FREE TOOLS',
		isHeader: true
	},

	{
		label: 'DCP Cine Player',
		icon: 'bx bx-play-circle',
		subMenu: [
			{ label: 'Overview & Download', link: base + '/dcp-cine-player/' },
			{ label: 'Get a FREE Licence', link: base + '/dcp-cine-player/activation/' },
			{ label: 'Features', link: base + '/dcp-cine-player/features/' },
			{ label: 'AirPlay Casting', link: base + '/dcp-cine-player/casting/' },
			{ label: 'Integration', link: base + '/dcp-cine-player/integration/' },
			{ label: 'IMF Playback', link: base + '/dcp-cine-player/imf/' },
			{ label: 'EAR-Tech', link: base + '/dcp-cine-player/ear-tech/' },
			{ label: 'Display Lock', link: base + '/dcp-cine-player/ddl/' },
			{ label: 'Operations', link: base + '/dcp-cine-player/operations/' },
			{ label: 'Security', link: base + '/dcp-cine-player/security/' },
			{ label: 'Installation', link: base + '/dcp-cine-player/install/' },
			{
				label: 'User Manual',
				isChildItem: true,
				childItems: [
					{ label: 'Manual Overview', link: base + '/dcp-cine-player/manual/' },
					{ label: 'Getting Started', link: base + '/dcp-cine-player/manual/getting-started/' },
					{ label: 'Install & Upgrade', link: base + '/dcp-cine-player/manual/install/' },
					{
						label: 'Complete Interface Manual',
						link: base + '/dcp-cine-player/manual/interface-reference/'
					},
					{ label: 'Daily Operation', link: base + '/dcp-cine-player/manual/operations/' },
					{ label: 'IMF Guide', link: base + '/dcp-cine-player/manual/imf/' },
					{ label: 'EAR-Tech Guide', link: base + '/dcp-cine-player/manual/ear-tech/' },
					{ label: 'Display Lock Guide', link: base + '/dcp-cine-player/manual/ddl/' },
					{ label: 'Security & Hardening', link: base + '/dcp-cine-player/manual/security/' },
					{ label: 'AirPlay Casting', link: base + '/dcp-cine-player/manual/casting/' },
					{ label: 'Storage & Recovery', link: base + '/dcp-cine-player/manual/storage/' },
					{ label: 'Monitoring', link: base + '/dcp-cine-player/manual/monitoring/' },
					{ label: 'Identity & Integration', link: base + '/dcp-cine-player/manual/integration/' },
					{ label: 'Troubleshooting', link: base + '/dcp-cine-player/manual/troubleshooting/' }
				]
			}
		]
	},

	{
		label: 'Cinema Sign',
		icon: 'bx bx-tv',
		subMenu: [
			{ label: 'About', link: base + '/cinema-sign/about' },
			{ label: 'Features', link: base + '/cinema-sign/features' },
			{ label: 'Deployment', link: base + '/cinema-sign/deployment' },
			{ label: 'Data Sources', link: base + '/cinema-sign/data-sources/' },
			{
				label: 'Quick Operator Guide',
				link: base + '/cinema-sign/operator-guide/'
			},
			{ label: 'User Manual', link: base + '/cinema-sign/manual/' }
		]
	},

	{
		label: 'Non-Sync Player',
		icon: 'bx bx-music',
		subMenu: [
			{ label: 'Overview', link: base + '/non-sync-player/about/' },
			{ label: 'Features', link: base + '/non-sync-player/features/' },
			{ label: 'Quick Guide', link: base + '/non-sync-player/quick-guide/' },
			{ label: 'Deployment', link: base + '/non-sync-player/deployment/' },
			{ label: 'User Manual', link: base + '/non-sync-player/manual/' }
		]
	},

	{
		label: 'CatcherTMS',
		icon: 'bx bx-server',
		subMenu: [
			{ label: 'About', link: base + '/catcher-tms/about' },
			{ label: 'Features', link: base + '/catcher-tms/features' },
			{ label: 'TMS — In Development', link: base + '/catcher-tms/roadmap' }
		]
	},

	{ label: 'Other Free Tools', icon: 'bx bx-extension', link: base + '/free_tools' },

	{
		label: 'ADMIN ONLY PAGES',
		isHeader: true,
		auth_access: ['admin']
	},
	{
		label: 'Admin Tools',
		icon: 'bx bx-lock',
		auth_access: ['admin'],
		subMenu: [
			{ label: 'User Editor', link: base + '/admin/user_editor' },
			{ label: 'Chain/Circuit Editor', link: base + '/admin/chain_editor' },
			{ label: 'Locations', link: base + '/admin/locations' },
			{ label: 'Bulk Asset Delete', link: base + '/admin/asset_cleanup/', staff_only: true },
			{ label: 'Activity Log', link: base + '/admin/activity_log' },
			{ label: 'FTP Sources', link: base + '/admin/ftp_sources' },
			{ label: 'FTP Download Queue', link: base + '/admin/ftp_download_queue' },
			{ label: 'KDM Email Queue', link: base + '/admin/kdm_email_queue' },
			{ label: 'DCP Cine Player Licences', link: base + '/admin/player_licenses' },
			{ label: 'Cinema Sign Media', link: base + '/admin/cinema_sign_media' },
			{ label: 'Cinema Sign Activity', link: base + '/admin/cinema_sign_activity' },
			{ label: 'NonSync Player Activity', link: base + '/admin/non_sync_player_activity' },
			{ label: 'FLM Peers', link: base + '/admin/flm_peers' },
			{ label: 'Active Users', link: base + '/admin/active_users' }
		]
	},
	{
		label: 'Debug Tools',
		icon: 'bx bx bx-bug',
		link: base + '/admin/debug_tools',
		auth_access: ['admin']
	},
	{
		label: 'Junk Pages for DEV',
		isHeader: true,
		auth_access: ['admin']
	},
	{
		label: 'Authentication',
		icon: 'bx bx-user-circle',
		auth_access: ['admin'],
		subMenu: [
			{ label: 'Login', link: base + '/auth/login' },
			{ label: 'Register', link: base + '/auth/register' },
			{ label: 'Recover Password', link: base + '/auth/recoverpw' },
			{ label: 'Lock Screen', link: base + '/auth/lock-screen' },
			{ label: 'Confirm Email', link: base + '/auth/confirm-mail' },
			{ label: 'Email verification', link: base + '/auth/email-verification' },
			{ label: 'Two Step Verification', link: base + '/auth/two-step-verification' }
		]
	},
	{
		label: 'Utility',
		icon: 'bx bx-file',
		auth_access: ['admin'],
		subMenu: [
			{ label: 'Maintenance', link: base + '/pages/maintenance' },
			{ label: 'Coming Soon', link: base + '/pages/comingsoon' },
			{ label: 'Error 404', link: base + '/pages/404' },
			{ label: 'Error 500', link: base + '/pages/500' }
		]
	},
	{
		label: 'Multi Level',
		icon: 'bx bx-share-alt',
		auth_access: ['admin'],
		subMenu: [
			{ label: 'Level 1.1', link: 'javascript:void(0);' },
			{
				label: 'Level 1.2',
				link: 'javascript:void(0);',
				isChildItem: true,
				childItems: [
					{ label: 'Level 2.1', link: 'javascript:void(0);' },
					{ label: 'Level 2.2', link: 'javascript:void(0);' }
				]
			}
		]
	}
];

const MOCK_DATA = {
	Navdata
};

export default MOCK_DATA;
